import styles from "./styles.scss";
import { FC } from "react";
import clsx from "clsx";
import { Back } from "@/assets/icons";
import { BackButtonProps } from "./types";

export const BackButton: FC<BackButtonProps> = ({
  onClick,
  className,
  iconClassName,
}) => {
  return (
    <button
      className={clsx(styles.backButton, className)}
      type="button"
      onClick={onClick}
    >
      <Back className={clsx(styles.backIcon, iconClassName)} />
    </button>
  );
};
